import sliceGeometry from './sliceGeometry/sliceGeometry';

export function sliceByPlanes(root, planesArray) {
  root.updateWorldMatrix(true, true);
  root.traverse((object) => {
    if (object.geometry) {
      object.geometry = object.geometry.clone(true);
      const matrix = object.matrixWorld;
      object.geometry.applyMatrix4(matrix);
      for (const plane of planesArray) {
        const geometry = sliceGeometry(object.geometry, plane);
        object.geometry = geometry;
      }
      object.geometry.applyMatrix4(matrix.clone().invert());
    }
  });
}
